// C_CHART_Node_DepthAboveInvert.tsx
import { useState } from "react"
import "./index.css"
import { 
  // State initializers
  IOutRechartsLinear_default,
  IDefault,
  // Data Type options
  OUTDATATYPES,
  // swmmReact data management
  OpenDefaultOutFileHeadless, 
  OUTDirectoryParser, 
  OUTObjectType_Headless, 
  OUTDataType_Headless, 
  OUTSeriesTransformer, 
  OUTNodesMultiSelect,
  // Charting component
  OUTLineChartTime_Recharts
  } from "./swmmreact"

// This is a contained form that allows a user to 
// select an object and display the related output
// using a Recharts structure.
const C_CHART_Node_DepthAboveInvert = () => {
  // State for transformer/charting components.
  const [values, setValues] = useState(IOutRechartsLinear_default)
  // State for contents of the .out file.
  const [outModel, setOut] = useState(new ArrayBuffer(0))

  // handleChange updates the 'values' object within the controls.
  const handleChange = (e:IDefault) => {
    setValues(oldValues => ({ ...oldValues, [e.name]: e.value }))
  }

  // Set the dimensions for the chart
  let height = 250
  let width = '95%'

  return (
    <>
      {/* Open the default binary file. */}
      <OpenDefaultOutFileHeadless setOut={setOut}
        fileNames={[ process.env.PUBLIC_URL + '/Example1.out']}/>

      {/* Parse the binary file, add the outdir to the 'values' object */}
      <OUTDirectoryParser outbin={outModel} 
        onChange={handleChange} />
      
      {/* Set the object type to 'NODE' */}
      <OUTObjectType_Headless type='NODE' 
        onChange={handleChange} />

      {/* Identify the type of data to be charted. */}
      <OUTDataType_Headless dataType={OUTDATATYPES.NODE.DEPTHABOVEINVERT} 
        onChange={handleChange} />
      
      {/* Transform the .out file data into chartable info. */}
      <OUTSeriesTransformer values={values} 
        onChange={handleChange} outbin={outModel} />
      
      {/* Create the chart. */}
      <OUTLineChartTime_Recharts values={values} 
        width={width} height={height}/>
      
      {/* Use a multiselect control to select object(s) to chart. */}
      <label htmlFor='node'>Node</label>
      <OUTNodesMultiSelect outdir={values.outdir} 
        onChange={handleChange} />
    </>
  )
}

export { C_CHART_Node_DepthAboveInvert }